import {
	GetElementsById,
	RegisterP5Sketch,
	SetOnChangeHandler,
	SetupSaveAndShareButton,
} from "../shared";
import {
	CreateControlsGroup,
	CreateElementInfo,
	GetControlGroupValues,
} from "../controls";
import {
	CalculateCanvasSize,
	CalculateCanvasSizeArgs,
	DisplayInfo,
} from "../display";
import { StrEncoder, NewIntEncoder, NewFloatEncoder } from "../encoders";
import { GetRandomSeedNumber, GetRandomSeedString, NewRNG01 } from "../math/random";
import { CreateNoise3D } from "../math/noise";
import { SetCanvasPositionByTarget } from "../p5/p5_helper";

const { save, share, RandomizeSeed } = GetElementsById(
	"save",
	"share",
	"RandomizeSeed"
).ToType<HTMLButtonElement>();
const { Controls, Seed } = CreateControlsGroup(
	CreateElementInfo("c1", "#F44336", StrEncoder),
	CreateElementInfo("c2", "#2986CC", StrEncoder),
	CreateElementInfo("c3", "#FFD966", StrEncoder),
	CreateElementInfo("cBg", "#EEEEEE", StrEncoder),
	CreateElementInfo("X", 4, NewIntEncoder(4)),
	CreateElementInfo("Y", 5, NewIntEncoder(5)),
	CreateElementInfo("Padding", 75, NewIntEncoder(75)),
	CreateElementInfo("TileSize", 100, NewIntEncoder(100)),
	CreateElementInfo("Seed", GetRandomSeedString(), StrEncoder),
	CreateElementInfo("Scale", 1, NewFloatEncoder(1))
);

function GetCanvasSizeInfo(): CalculateCanvasSizeArgs {
	const { X, Y, TileSize, Padding } = GetControlGroupValues(Controls);
	return {
		contentWidth: X * TileSize,
		contentHeight: Y * TileSize,
		contentPadding: Padding,
		titleArgs: {
			title: "Bauhaus",
			fontSize: 70,
			titleGap: 10,
		},
		footerArgs: {
			controls: Controls,
			fontSize: 10,
			urlGap: 10,
			margin: 5,
		},
	};
}

function setup() {
	SetOnChangeHandler(redraw, Controls);
	SetupSaveAndShareButton(save, share);
	RandomizeSeed.onclick = () => {
		Seed.Setter(GetRandomSeedString());
	};

	const { width, height } = CalculateCanvasSize(GetCanvasSizeInfo());


	const r = createCanvas(width, height, "p2d");
	SetCanvasPositionByTarget(r.elt, "#canvas-target")

	noLoop();
	redraw();
}

function loop() {
	const { X, Y, TileSize, c1, c2, c3, cBg, Seed, Scale } =
		GetControlGroupValues(Controls);

	const { width, height, startX, startY } = CalculateCanvasSize(
		GetCanvasSizeInfo()
	);
	resizeCanvas(width, height, true);

	background(cBg);
	noStroke();
	ellipseMode("corner");

	const noise = CreateNoise3D(NewRNG01(Seed));

	for (let x = 0; x < X; x++) {
		let xCanvas = x * TileSize + startX;
		for (let y = 0; y < Y; y++) {
			let yCanvas = y * TileSize + startY;

			const col = noise(x * Scale, y * Scale, 0);
			const shape = noise(x * Scale, y * Scale, 100);

			if (col < 0.33) {
				fill(c1);
			} else if (col < 0.66) {
				fill(c2);
			} else {
				fill(c3);
			}

			if (shape < 0.33) {
				rect(xCanvas, yCanvas, TileSize, TileSize);
			} else if (shape < 0.66) {
				circle(xCanvas, yCanvas, TileSize);
			}
		}
	}

	fill("#1a1a1a");
	textFont("monospace");
	DisplayInfo(GetCanvasSizeInfo());
}

RegisterP5Sketch(setup, loop);
